// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__32ylA","gfeWrapper":"CalendarEvent_gfeWrapper__1nmqN"};